export default [
  {
    label: "4th",
    value: "4"
  },
  {
    label: "5th",
    value: "5"
  },
  {
    label: "6th",
    value: "6"
  },
  {
    label: "7th",
    value: "7"
  },
  {
    label: "8th",
    value: "8"
  },
  {
    label: "9th",
    value: "9"
  },
  {
    label: "10th",
    value: "10"
  },
  {
    label: "11th",
    value: "11"
  },
  {
    label: "12th",
    value: "12"
  },
  {
    label: "Higher education",
    value: "Higher education"
  }
];
